import { space } from "@smartsheet/design-tokens";
import { BaseButtonStyledProps, ButtonAppearances } from "../types";
import { mapButtonAppearance } from "./mapButtonAppearance";

export const ursaPadding = {
    xsmall: space.space05,
    small: space.space10,
    medium: "6px", //space15 doesn't exist
    large: space.space20,
};

export const getButtonPadding = ({ hasOnlyIcons, hasNoIcons, appearance, size, themeMode }: BaseButtonStyledProps) => {
    const actualAppearance: ButtonAppearances | "link" = mapButtonAppearance(appearance, themeMode);

    switch (actualAppearance) {
        // For Lodestar buttons.
        case "borderless":
            // If there's only icons, don't add any padding
            if (hasOnlyIcons || appearance === "link") {
                // 0 is important; some browsers have a user agent style with padding that we don't want
                return "0";
            }
            return `0 ${space.space10}`;
        case "primary":
        case "secondary":
        case "destructive":
        case "secondary-destructive":
        case "share":
            // If there's only icons, don't add any padding
            if (hasOnlyIcons || appearance === "link") {
                // 0 is important; some browsers have a user agent style with padding that we don't want
                return "0";
            }
            if (hasNoIcons) {
                return `0 ${space.space50}`;
            }
            return `0 ${space.space10}`;

        // For Ursa buttons.
        case "primary-filled":
        case "primary-empty":
        case "secondary-filled":
        case "secondary-outlined":
        case "secondary-empty":
        case "canvas-filled":
        case "canvas-empty":
        case "destructive-filled":
        case "destructive-empty":
            return `0 var(--sds--button--padding-x--${size}, calc(${ursaPadding[size]} - 1px))`;
    }
};
